<template>
  <main class="eventadmin" style="position:absolute;width:100%">
    <div class="asdf">
      <!--v-toolbar flat dense class="asdf1">
      <v-toolbar-title>{{event ? event.title: "loading"}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-btn text>Link 1</v-btn>
        <v-btn text>Link 2</v-btn>
        <v-btn text>Link 3</v-btn>
      </v-toolbar-items>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-btn icon>
          <v-icon>mdi-export-variant</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-delete-circle</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-plus-circle</v-icon>
        </v-btn>
      </template>
      </v-toolbar-->
      <h1 v-if="event">Event Admin</h1>
      <router-view></router-view>
    </div>
  </main>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      eventId: null
    };
  },

  components: {},

  methods: {
    ...mapActions("events", ["insert", "set", "delete", "fetchById"])
  },
  computed: {
    event() {
      const pageId = this.$route.params.eventid;
      return this.$store.state.events.data[pageId];
    }
  },

  created() {
    let eventId = this.$route.params.eventid;

    this.$store
      .dispatch("slides/openDBChannel", {
        where: [["event", "==", eventId]]
      })
      .catch(e => {
        console.log("dispatched called with error");
        console.log(e);
      });

    //this.fetchById(eventId);
    /*this.$store.dispatch('openPage/fetchAndAdd', {pageId})
      .catch(error => {
        if (error === 'preventInitialDocInsertion') {
          // an initial doc insertion was prevented
        }
      })*/
  },
  beforeDestroy() {
    let eventId = this.$route.params.eventid;
    this.$store
      .dispatch("slides/closeDBChannel", {
        where: [["event", "==", eventId]]
      })
      .catch(e => {
        console.log("dispatched called with error");
        console.log(e);
      });
  }
};
</script>

<style scoped>
.eventadmin {
  min-height: 100%;
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.asdf {
  flex: 1;
}
.asdf1 {
}
</style>